import { render, staticRenderFns } from "./AddCommission.vue?vue&type=template&id=5fc59db2"
import script from "./AddCommission.vue?vue&type=script&lang=js"
export * from "./AddCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports